import { Outlet } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import styled from "styled-components";

export default function LayoutComBackground() {
  return (
    <Container>
      <Header />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  background-image: url("/img/ipanema.jpeg");
  background-position: top;
  background-size: cover;
  background-attachment: fixed;

  overflow-x: hidden;
`;

const Main = styled.main`
  flex: 1;
`;
